import * as React from 'react';

import type { IUserContextValue } from './UserContext';
import UserContext from './UserContext';

const withUserContext = <T extends IUserContextValue, >(
  Component: React.ComponentType<T>,
) => (function UserContextComponent(props: Pick<T, Exclude<keyof T, keyof IUserContextValue>>) {
    return (
      <UserContext.Consumer>
        {(contexts) => <Component {...props as T} {...contexts} />}
      </UserContext.Consumer>
    );
  });

export default withUserContext;
